<template>
  <div class="box">
    <Echart
      id="rightCenterChart"
      :options="options"
      height="320px"
      width="550px"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      number: 0,
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["已执行", "未执行", "执行率%"],
        },
        grid: {
            top: "10%",
            left: "0%",
            right: "18%",
            bottom: "24%",
            containLabel: true
          },
        xAxis: [
          {
            type: "category",
            data: this.date,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value} ",
            },
          },
          {
            type: "value",
            axisLabel: {
              formatter: "",
            },
          },
        ],
        series: [
          {
            name: "已执行",
            type: "bar",
            data: this.alreadyData,
          },
          {
            name: "未执行",
            type: "bar",
            data: this.notData,
          },
          {
            name: "执行率%",
            type: "line",
            data:this.percentageData
          },
        ],
        };
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.$nextTick(() => {
      // this.getEcharts();
    });
  },
  methods: {
    async getEcharts() {
      let _this = this;
      const { success, data } = await _this.Api.getTaskCarriedOut();
      if (success) {
        console.log("任务执行：", data);
        this.mainData = data;
        // 数据处理
        data.forEach((ele) => {
          ele.name = this.$moment(ele.name).format("MM-DD");
          this.date.push(ele.name);
          this.alreadyData.push(ele.value);
          this.notData.push(ele.total - ele.value);
          if (ele.value != 0) {
            this.percentageData.push(((ele.value / ele.total) * 10000) / 100.0);
          }else {
            this.percentageData.push(0)
          }
        });
      }
    },
  },
  mounted() {}
};
</script>
<style lang="scss" scope>
.box {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  margin-left: 50px;
  .tit {
    float: left;
    margin-top: 18px;
    font-size: 28px;
  }
  .title {
    float: right;
    margin-top: -40px;
    margin-right: 56px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/rightCenterChart/index.vue